import { render, staticRenderFns } from "./IndividualExpanded.vue?vue&type=template&id=ad9b0954&"
import script from "./IndividualExpanded.vue?vue&type=script&lang=js&"
export * from "./IndividualExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports